import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { viewType: String }
  static targets = ["typeSelect", "textFields", "calendarFields", "formatSelect", "titleModeSelect", "headingTransformGroup", "headingTransformSelect"]

  connect() {
    this.change()
    this.syncTextOptions()
  }

  change() {
    const type = this.hasTypeSelectTarget ? this.typeSelectTarget.value : (this.viewTypeValue || "text")
    const textSelected = type === "text"

    if (this.hasTextFieldsTarget) this.textFieldsTarget.classList.toggle("hidden", !textSelected)
    if (this.hasCalendarFieldsTarget) this.calendarFieldsTarget.classList.toggle("hidden", textSelected)
  }

  syncTextOptions() {
    if (!this.hasFormatSelectTarget || !this.hasTitleModeSelectTarget) return

    const format = this.formatSelectTarget.value
    const titleMode = this.titleModeSelectTarget.value
    const allowHeadingTransform = format === "markdown" && titleMode === "headings"

    if (this.hasHeadingTransformGroupTarget) {
      this.headingTransformGroupTarget.classList.toggle("hidden", !allowHeadingTransform)
    }

    if (this.hasHeadingTransformSelectTarget) {
      this.headingTransformSelectTarget.disabled = !allowHeadingTransform
      if (!allowHeadingTransform) this.headingTransformSelectTarget.value = "none"
    }

    const options = Array.from(this.titleModeSelectTarget.options)
    options.forEach((option) => {
      const inlineOnly = option.value === "inline"
      const markdownOnly = option.value === "headings"

      if (format === "plain_text") {
        option.hidden = markdownOnly
      } else {
        option.hidden = inlineOnly
      }
    })

    const currentValue = this.titleModeSelectTarget.value
    if (format === "plain_text" && currentValue === "headings") this.titleModeSelectTarget.value = "inline"
    if (format === "markdown" && currentValue === "inline") this.titleModeSelectTarget.value = "headings"
  }
}
